const valueBoundary = {
  en: "Your kundali and first chart-grounded answer are free.",
  hi: "Aapki kundali aur pehla chart-grounded answer free hai.",
};

const paidBoundary = {
  en: "A paid continuation may follow; its price and duration appear before payment.",
  hi: "Uske baad paid continuation aa sakta hai; price aur duration payment se pehle dikhega.",
};

const phonePurpose = {
  en: "A mobile number is required to save this private reading so you can reopen it.",
  hi: "Private reading save karke phir kholne ke liye mobile number required hai.",
};

const consentBoundary = {
  en: "Required mobile capture does not opt you into marketing; recurring messages need a separate opt-in.",
  hi: "Required mobile capture marketing opt-in nahi hai; recurring messages ke liye alag opt-in chahiye.",
};

export const AI_ASTROLOGER_ONBOARDING_CONTRACT = {
  hero: {
    eyebrow: "AI Vedic Astrology Consultation",
    title: "Free AI Astrology Chat: Why Does This Keep Happening?",
    body: "Start with the pattern on your mind. Your AI Jyotishi then reads the graha, house, and dasha behind it.",
    visualTitle: "See how your chart becomes an answer",
    visualBody:
      "Your question sets the lens. The engine calculates the chart and timing; your AI Jyotishi explains the pattern and a practical upay.",
    cardEyebrow: "Your AI Jyotishi",
    cardTitle: "What keeps repeating in your life?",
    cardBody:
      "Choose the concern first. Your kundali will show which graha, house, or dasha is shaping it.",
    signals: ["No app download", "Engine-calculated chart", "First answer free"],
  },
  concerns: {
    legend: "What is on your mind right now?",
    helper:
      "Pick the closest pattern. Your AI Jyotishi will keep it open while your kundali is calculated.",
    changeLabel: "Choose a different concern",
    options: [
      {
        key: "marriage_delay",
        title: "Why does marriage keep getting delayed?",
        prompt: "Which house, dasha, or dosha is affecting my marriage timing?",
        seoIntent: "chart_report",
        concern: "marriage",
        lens: "7th house · dasha",
      },
      {
        key: "career_stuck",
        title: "Why does career growth stay blocked?",
        prompt: "Which graha is blocking my 10th house, and what upay fits?",
        seoIntent: "chart_report",
        concern: "career",
        lens: "10th house · career",
      },
      {
        key: "money_drain",
        title: "Why does money come and immediately disappear?",
        prompt: "Which chart factor is affecting my ability to keep and grow money?",
        seoIntent: "chart_report",
        concern: "wealth",
        lens: "2nd and 11th houses",
      },
      {
        key: "pattern_repeat",
        title: "Why does the same relationship pattern repeat?",
        prompt: "Which chart factors could explain the pattern repeating in my relationships?",
        seoIntent: "chart_report",
        concern: "marriage",
        lens: "7th house · Shukra",
      },
      {
        key: "other_concern",
        title: "Why do I feel blocked no matter what I do?",
        prompt: "Which graha, house, or dasha explains the pattern on my mind?",
        seoIntent: "chart_report",
        concern: undefined,
        lens: "Graha · house · dasha",
      },
    ],
  },
  trust: { valueBoundary, paidBoundary, phonePurpose, consentBoundary },
} as const;

const contract = AI_ASTROLOGER_ONBOARDING_CONTRACT;

export const AI_ASTROLOGER_TRUST_COPY = {
  en: {
    reassurance: `${valueBoundary.en} ${paidBoundary.en}`,
    savedNote: `${phonePurpose.en} ${consentBoundary.en}`,
    freeFaqAnswer: `${valueBoundary.en} There is no running per-minute meter. ${paidBoundary.en}`,
    detailsFaqAnswer: `Your name, birth date, and birth place calculate the kundali; birth time improves Lagna and house accuracy. ${phonePurpose.en} ${consentBoundary.en}`,
    availability: `Ishvaram is available instantly. ${valueBoundary.en} ${paidBoundary.en}`,
    freeSectionBoundary: `${valueBoundary.en} ${paidBoundary.en}`,
    comparisonCost: "Free kundali and first answer; clearly priced continuation may follow",
    startRequirements: "Concern, birth details, and required mobile",
  },
  hi: {
    reassurance: `${valueBoundary.hi} ${paidBoundary.hi}`,
    savedNote: `${phonePurpose.hi} ${consentBoundary.hi}`,
  },
  schemaDescription: `${valueBoundary.en} ${paidBoundary.en}`,
  offerName: valueBoundary.en,
  hero: contract.hero,
} as const;
